<div class="methodology-animated">
    <div style="position: relative; max-width: 400px; margin: auto;">
        <div *ngIf="!BrowserDetect.isMSBrowser()" class="patch patch-1"></div>
        <div *ngIf="!BrowserDetect.isMSBrowser()" class="patch patch-2"></div>
        <figure>
            <img *ngIf="!BrowserDetect.isMSBrowser()" src="/assets/images/net-animated-base.png" alt="Methodology" class="shape-circle-image">
            <img *ngIf="BrowserDetect.isMSBrowser()" src="/assets/images/net-animated-base-static.png" alt="Methodology" class="shape-circle-image">
        </figure>
    </div>

    <ul class='circle-container'>
        <li *ngFor="let indicator of areaIdList" [class.showAreaName]="true">
            <div [ngClass]="customClass" class="popRegular d-flex flex-column align-items-center justify-content-center text-uppercase text-center branded04">
                <i class="medIco2 icon-{{getIcon(areas[indicator].value)}}" [class.branded01]="purple"></i>
                <span class="d-none d-md-block popRegular" [ngClass]="customClass ? customClass : 'branded04'" [innerHTML]="indicator | translate"></span>
            </div>
        </li>
    </ul>
</div>
